<template>
<component :is="name" v-if="content" :context="context"/>
</template>
<script>
import Vue from 'vue';
let count = 0;

export default {
    props: {
        content: {},
        context: {},
        escaped: {},
    },
    data () {
        return {
            name: this.generateComponent(),
        };
    },
    watch: {
        content () {
            this.name = this.generateComponent();
        },
    },
    methods: {
        generateComponent () {
            let name = `tpl${count++}t${new Date().getTime()}`;
            let content = (this.escaped ? unescape(this.content || '') : this.content || '')
                .split('<if').join('<template v-slot:if')
                .split('<else').join('<template v-slot:else')
                .split('<then').join('<template v-slot:then')
                .split('</if').join('</template')
                .split('</else').join('</template')
                .split('</then').join('</template');

            Vue.component(name, {
                props: ['context'],
                template: `<span>${content}</span>`,
                components: {
                    'appoint-info': require('@/vue/markup/appoint-info.vue').default,
                    'context-for-desktop': require('@/vue/markup/context-for-desktop.vue').default,
                    'context-for-mobile': require('@/vue/markup/context-for-mobile.vue').default,
                    'context-has-filters': require('@/vue/markup/context-has-filters.vue').default,
                    'context-history': require('@/vue/markup/context-history.vue').default,
                    'context-multiple': require('@/vue/markup/context-multiple.vue').default,
                    'context-no-filters': require('@/vue/markup/context-no-filters.vue').default,
                    'context-one': require('@/vue/markup/context-one.vue').default,
                    'context-question': require('@/vue/markup/context-question.vue').default,
                    'context-question-value': require('@/vue/markup/context-question-value.vue').default,
                    'section-collapsible': require('@/vue/markup/section-collapsible.vue').default,
                    'section-collapsible-title': require('@/vue/markup/section-collapsible-title.vue').default,
                    'section-collapsible-content': require('@/vue/markup/section-collapsible-content.vue').default,
                    'popup-trigger': require('@/vue/markup/popup-trigger').default,
                    popup: require('@/vue/markup/popup').default,
                    'popup-content': require('@/vue/markup/popup-content').default,
                    'popup-header': require('@/vue/markup/popup-header').default,
                    'tab-navigation': require('@/vue/markup/tab-navigation').default,
                    'tab-header': require('@/vue/markup/tab-header').default,
                    'tab-header-item': require('@/vue/markup/tab-header-item').default,
                    'tab-content': require('@/vue/markup/tab-content').default,
                    acknowledgement: require('@/vue/markup/acknowledgement').default,
                    'count-cards': require('@/vue/markup/count-cards.vue').default,
                    distance: require('@/vue/markup/distance.vue').default,
                    'filter-cards': require('@/vue/markup/filter-cards.vue').default,
                    'history-title': require('@/vue/markup/history-title.vue').default,
                    'history-value': require('@/vue/markup/history-value.vue').default,
                    spinner: require('@/vue/markup/spinner.vue').default,
                    'submit-button': require('@/vue/markup/submit-button.vue').default,
                    'main-menu-button': require('@/vue/markup/clear-button.vue').default,
                    'go-back-button': require('@/vue/markup/clear-button.vue').default,
                    'go-forward-button': require('@/vue/markup/clear-button.vue').default,
                    value: require('@/vue/markup/value.vue').default,
                    when: require('@/vue/markup/when.vue').default,

                    ...require('@clearwave/odoro-markup/lib/utils/components.js').default,
                },
            });

            return name;
        },
    },
};
</script>
